import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import SidePanel from '../components/SidePanel/SidePanel';
import axios from 'axios';
import TicketEditForm from '../components/TicketEditForm'
import WelcomeMessage from '../components/WelcomeMessage';
import Sidebar from '../components/Sidebar/Sidebar';
import '../styles/Dashboard.scss'; // Import SCSS styling


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const HomePage = () => {
    const { authTokens, logoutUser, user } = useContext(AuthContext);
    const [profile, setProfile] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [ticketsR, setTicketsReload] = useState(false);
    const [nextPage, setNextPage] = useState(null);
    const [previousPage, setPreviousPage] = useState(null);
    // const [categoryNextPage, setCategoryNextPage] = useState(null);
    // const [categoryPreviousPage, setCategoryPreviousPage] = useState(null);
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [modalContent, setModalContent] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [categoryData, setCategoryData] = useState(null);
    const [categoryTitle, setCategoryTitle] = useState('Tickets');
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
    const [isSideBarOpen, setIsSideBarOpen] = useState(false);
    // const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    console.log(categoryData)

    const [ftnToDo, setFtnToDo] = useState(null);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [stats, setStats] = useState({
        Pending: 0,
        Today: 0,
        Ongoing: 0,
        Postponed: 0,
        Total: 0,
        Month: 0,
    });

    const [month, setMonth] = useState('');
    const [summaryData, setSummaryData] = useState({
        today: { new_installation: 0, los: 0, relocation: 0, Technical: 0 },
        month: { new_installation: 0, los: 0, relocation: 0, Technical: 0 },
    });

    const [msg, setMessage] = useState(null)

    const base_url = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/today'



    const getProfile = async () => {
        let response = await fetch('https://tickets-api-q5n6.onrender.com/api/profile', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + String(authTokens.access),
            },
        });
        let data = await response.json();


        if (response.status === 200) {
            setProfile(data);

        } else {
            logoutUser();
        }
    };



    useEffect(() => {
        console.log('HomePage useEffect called', user);

        if (!user) {
            logoutUser();
        }

        setMessage('Fetching Data...')
        getProfile();
        fetchTickets(base_url);
        fetchTicketStats()
        fetchSummaryData()

        const currentMonth = new Date().toLocaleString('en-US', { month: 'short' });
        setMonth(currentMonth);

    }, []);

    useEffect(() => {
        setSelectedTicket(null)
        fetchTickets(base_url);
        fetchTicketStats()
        fetchSummaryData()
    }, [ticketsR]);

    const fetchTickets = (url) => {
        setLoading(true);
        axios.get(url)
            .then(response => {
                setTickets(response.data.results);
                setNextPage(response.data.next);
                setPreviousPage(response.data.previous);
                setLoading(false);

            })
            .catch(error => {
                setLoading(false);
            });
    };

    // Fetch ticket stats from the backend
    const fetchTicketStats = async () => {
        try {
            const response = await axios.get('https://tickets-api-q5n6.onrender.com/api/ticket-stats');
            setStats(response.data);  // Update state with fetched stats
        } catch (error) {
            console.error('Error fetching ticket stats:', error);
        }
    };

    const fetchSummaryData = async () => {
        try {
            const response = await axios.get('https://tickets-api-q5n6.onrender.com/api/ticket-summary');
            setSummaryData(response.data);

            const currentMonth = new Date().toLocaleString('en-US', { month: 'short' });
            setMonth(currentMonth);
        } catch (error) {
            console.error('Error fetching summary data:', error);
        }
    };

    const handleButtonClick = (ticketId, fn) => {
        setFtnToDo(fn)
        openModal(ticketId);
    };




    const openModal = (category) => {
        setIsModalOpen(true);
        setCategoryLoading(true);

        let apiEndpoint = '';

        if (typeof category === 'number') {
            apiEndpoint = `https://tickets-api-q5n6.onrender.com/api/view_ticket/${category}`;
            view_ticket(apiEndpoint);

        } else {
            switch (category) {
                case 'This Month':
                    setCategoryTitle('This Month Tickets');
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/this_month';
                    fetch_s_Tickets(apiEndpoint);
                    break;
                case 'Pending':
                    setCategoryTitle('Pending Tickets');
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/pending';
                    fetch_s_Tickets(apiEndpoint);
                    break;
                case 'Today':
                    setCategoryTitle('Today Tickets');
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/today';
                    fetch_s_Tickets(apiEndpoint);
                    break;

                case 'Total Tickets':
                    setCategoryTitle('Total Tickets');
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/total';
                    fetch_s_Tickets(apiEndpoint);
                    break;

                case 'Ongoing':
                    setCategoryTitle('Ongoing Tickets');
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/ongoing';
                    fetch_s_Tickets(apiEndpoint);
                    break


                case 'Postponed':
                    setCategoryTitle('Postponed Tickets');
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/postponed';
                    fetch_s_Tickets(apiEndpoint);
                    break

                default:
                    apiEndpoint = 'https://tickets-api-q5n6.onrender.com/api/get_time_tickets/total';
                    fetch_s_Tickets(apiEndpoint);
                    break;
            }
        }



    };

    const fetch_s_Tickets = (url) => {
        setCategoryLoading(true);
        axios.get(url)
            .then(response => {
                setCategoryData(response.data.results);

                setCategoryLoading(false);
            })
            .catch(error => {
                setCategoryLoading(false);
            });
    };

    const view_ticket = (url) => {
        setCategoryLoading(true);
        axios.get(url)
            .then(response => {
                setSelectedTicket(response.data);
                setCategoryLoading(false);
            })
            .catch(error => {
                setCategoryLoading(false);
            });
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setCategoryData(null);
        setLoading(false)
        setSelectedTicket(null)
        setFtnToDo(null)
    };




    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedTicket((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (updatedTicket) => {
        const ticketDataString = updatedTicket.get("ticket");
        const ticketData = JSON.parse(ticketDataString);
        const imageFile = updatedTicket.get("image");
        const apiUrl = `https://tickets-api-q5n6.onrender.com/api/update_ticket/${ticketData.ticket_id}`;

        const formData = new FormData();
        formData.append("ticket", JSON.stringify(ticketData));
        if (imageFile) {
            formData.append("image", imageFile);
        }


        axios
            .patch(apiUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data", // Ensure proper handling of FormData
                },
            })
            .then((response) => {
                setMessage('Ticket Updated Successfully')
                if (ticketsR === true) {
                    setIsModalOpen(false)
                    setTicketsReload(false)
                    setFtnToDo(null)
                } else {
                    setIsModalOpen(false)
                    setTicketsReload(true)
                    setFtnToDo(null)
                }
            })
            .catch((error) => {
                setMessage('Error Updating the Ticket')
                // console.error("Error updating ticket:", error.response?.data || error.message);
            });
    };


    const handleNextPage = () => {
        if (nextPage) fetchTickets(nextPage);
    };

    const handlePreviousPage = () => {
        if (previousPage) fetchTickets(previousPage);
    };


    const openSidePanel = () => {
        setIsSidePanelOpen(true);
    };


    const closeSidePanel = () => {
        setIsSidePanelOpen(false);
        if (ticketsR === true) {
            setTicketsReload(false)
        } else {

            setTicketsReload(true)
        }
    };
    const openSideBar = () => {
        setIsSideBarOpen(true);
    };
    const closeSideBar = () => {
        setIsSideBarOpen(false);
    };

    const isStaff = profile?.user?.is_staff;

    // const getTicketData = async () => {
    //     let response = await fetch('https://tickets-api-q5n6.onrender.com/api/tickets', {
    //         method: 'GET',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             Authorization: 'Bearer ' + String(authTokens.access),
    //         },
    //     });
    //     let data = await response.json();
    //     if (response.status === 200) {
    //         setTickets(data);
    //     }
    // };

    return (
        <div className="dashboard-container">

            <div className="dashboard">

                <header className="dashboard-header p-4">
                    <h1>Tickets</h1>

                    <div>

                        {profile?.user?.is_staff && (
                            <button className="btn btn-sm btn-outline-info text-white m-3" onClick={openSidePanel}>
                                New Ticket
                            </button>
                        )}

                        {/* Sidebar toggler */}
                        <button
                            className="btn btn-sm text-white "
                            onClick={openSideBar}
                            style={{
                                alignItems: "center",
                                justifyContent: "center",
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                fontSize: "20px",
                            }}
                            aria-label="Toggle Sidebar"
                        >
                            ☰
                        </button>
                    </div>

                </header>
                {/* Side Panel Component */}
                <SidePanel isOpen={isSidePanelOpen} onClose={closeSidePanel} />
                <Sidebar isOpen={isSideBarOpen} onClose={closeSideBar} />




                <main className="dashboard-content">


                    <div className="top-bar mt-0 m-3">

                        <WelcomeMessage profile={profile} msg={msg} />
                        <b className='mt-2'> {isStaff ? "Staff Member" : "Technician"}</b>
                    </div>

                    <section className="stats">
                        {["Pending", "Today", "Ongoing", "Postponed", "Total", "Month"].map(
                            (stat, index) => (
                                <div
                                    key={index}
                                    className="stat-card"
                                    onClick={() => openModal(stat)}
                                >
                                    <span>{stat}</span>
                                    {/* <strong>{[2, 0, 7, 11, 1197, 124][index]}</strong> */}
                                    <strong>{stats[stat]}</strong>
                                </div>
                            )
                        )}
                    </section>

                    <section className="summary">
                        <div className="row">
                            <div className="col-md-1"></div>
                            <div className="col-md-4 card p-2 text-center" >
                                <h3>Today's Summary</h3>
                                <div className="summary-grid">
                                    <div>New Installation: <strong>{summaryData.today.new_installation}</strong></div>
                                    <div>LOS: <strong>{summaryData.today.los}</strong></div>
                                    <div>Relocation: <strong>{summaryData.today.relocation}</strong></div>
                                </div>
                            </div>
                            <div className="col-md-1"></div>
                            <div className="col-md-4 card p-2 text-center">
                                <h3>{month} Summary</h3>
                                <div className="summary-grid">
                                    <div>New Installation: <strong>{summaryData.month.new_installation}</strong></div>
                                    <div>LOS: <strong>{summaryData.month.los}</strong></div>
                                    <div>Relocation: <strong>{summaryData.month.relocation}</strong></div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="todays-tickets">
                        <h3>Today's Tickets</h3>
                        <div className="table-container">
                            <table className="tickets-table">
                                <thead>
                                    <tr>
                                        <th>Client</th>
                                        <th>Phone <br /> <small className='fs-7 text-info'>click to copy</small>
                                        </th>
                                        <th>Technician</th>
                                        <th>Type</th>
                                        <th>Priority</th>
                                        <th>Status</th>
                                        <th>Location</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(tickets) && tickets.map((ticket) => (
                                        <tr key={ticket.token}>
                                            <td style={{cursor: 'pointer'}} onClick={() => handleButtonClick(ticket.ticket_id, 'view')} className={ticket.ticket_status === "Pending" ? "text-danger fw-bold" : ticket.ticket_status === "Complete" ? "text-success fw-bold" : "fw-bold"} >{ticket.client_name}</td>
                                            <td
                                                style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}
                                                title="Click to copy"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(ticket.client_phone);
                                                    toast.success('📋 Phone number copied to clipboard!');
                                                }}
                                            >
                                                {ticket.client_phone}
                                            </td>
                                            <td>{ticket.technician_name}</td>
                                            <td>{ticket.ticket_type}</td>
                                            <td>{ticket.ticket_priority}</td>
                                            <td>{ticket.ticket_status}</td>
                                            <td>{ticket.location}</td>
                                            <td>
                                                <button className="view-button btn btn-sm btn-outline-info" onClick={() => handleButtonClick(ticket.ticket_id, 'view')}>View</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {loading && (
                                <div className="loading-spinner">
                                    <div className="spinner"></div>
                                    <p className="m-2">Fetching Ticket...</p>
                                </div>
                            )}

                            <div className="pagination-controls">
                                <button onClick={handlePreviousPage} disabled={!previousPage} className="pagination-button">
                                    Previous
                                </button>
                                <button onClick={handleNextPage} disabled={!nextPage} className="pagination-button">
                                    Next
                                </button>
                            </div>
                        </div>
                    </section>
                </main>

                {isModalOpen && (
                    <div className="modal">
                        <div className="modal-content">
                            <button className="close-modal" onClick={closeModal}>
                                ✖
                            </button>
                            {ftnToDo === "view" && (
                                <>
                                    <h2>View/Edit Ticket</h2>
                                    <div>
                                        {!selectedTicket ? (
                                            <p>Loading ticket details...</p>
                                        ) : (
                                            <>
                                                <TicketEditForm
                                                    ticket={selectedTicket}
                                                    onInputChange={handleInputChange}
                                                    onSubmit={handleSubmit}
                                                />

                                            </>
                                        )}
                                    </div>
                                </>
                            )}
                            {ftnToDo === "edit" && (
                                <>
                                    {/* Render your Edit Ticket modal content here */}
                                    <form>
                                        <label>
                                            Ticket Name:
                                            <input type="text" placeholder="Edit ticket name" />
                                        </label>
                                        <button type="submit">Save Changes</button>
                                    </form>
                                </>
                            )}
                            {!ftnToDo && (
                                <>
                                    <h2>{categoryTitle || "Tickets"}</h2>
                                    {categoryLoading ? (
                                        <p>Fetching tickets...</p>
                                    ) : (
                                        <div>
                                            <table className="category-table">
                                                <thead>
                                                    <tr>
                                                        <th>Client</th>
                                                        <th>Phone <br /> <small className='fs-7 text-info'>click to copy</small>
                                                        </th>
                                                        <th>Technician</th>
                                                        <th>Type</th>
                                                        <th>Priority</th>
                                                        <th>Location</th>
                                                        <th>Date</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {categoryData?.map((ticket, index) => (
                                                        <tr key={ticket.id}>
                                                        <td style={{cursor: 'pointer'}} onClick={() => handleButtonClick(ticket.ticket_id, 'view')} className={ticket.ticket_status === "Pending" ? "text-danger fw-bold" : ticket.ticket_status === "Complete" ? "text-success fw-bold" : "fw-bold"} >{ticket.client_name}</td>

                                                            {/* <td
                                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                                title="Click to copy"
                                                                onClick={() => navigator.clipboard.writeText(ticket.client_phone)}
                                                            >
                                                                {ticket.client_phone}
                                                            </td> */}

                                                            <td
                                                                style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'none' }}
                                                                title="Click to copy"
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(ticket.client_phone);
                                                                    toast.success('📋 Phone number copied to clipboard!');
                                                                }}
                                                            >
                                                                {ticket.client_phone}
                                                            </td>


                                                            <td>{ticket.technician_name}</td>
                                                            <td>{ticket.ticket_type}</td>
                                                            <td>{ticket.ticket_priority}</td>
                                                            <td>{ticket.location}</td>
                                                            <td>{ticket.datetime_registered}</td>
                                                            <td>
                                                                <button
                                                                    className="view-button btn btn-outline-primary btn-sm"
                                                                    onClick={() => handleButtonClick(ticket.ticket_id, "view")}
                                                                >
                                                                    View
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                            </table>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default HomePage;
